import React, { useEffect } from 'react';

const Offcanvas = ({
  show,
  onHide,
  title = "Menu",
  placement = "end",
  children,
  scrollable = false,
  backdrop = true,
  closeButton = true,
  size
}: any) => {

  // Lock body scroll when Offcanvas is open
  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    // Clean up on unmount
    return () => {
      document.body.style.overflow = '';
    };
  }, [show]);

  return (
    <>
      <div 
        className={`offcanvas offcanvas-${placement} ${show ? 'show' : ''}`}
        tabIndex={-1}
        id="offcanvasExample"
        aria-labelledby="offcanvasExampleLabel"
        style={{
          visibility: show ? 'visible' : 'hidden',
          ...(placement === 'end' ? { width: size } : {}),
          ...(backdrop ? {} : { pointerEvents: 'none' })
        }}
      >
        <div className="offcanvas-header border-bottom" >
          <div className="offcanvas-title" id="offcanvasRightLabel">
           <h5 className='text-center mb-0' style={{minWidth: "100px", maxWidth: "800px", overflowWrap: "break-word"}}>{title} </h5>
          </div>
          {closeButton && (
            <button 
              type="button" 
              className="btn-close text-reset me-4" 
              onClick={onHide}
              aria-label="Close"
            ></button>
          )}
        </div>
        <div className={`offcanvas-body p-0 ${scrollable ? 'overflow-y-auto' : ''}`}>
          {children}
        </div>
      </div>
      
      {show && backdrop && (
        <div 
          className="offcanvas-backdrop fade show" 
          onClick={onHide}
          style={{ opacity: show ? 0.5 : 0 }}
        ></div>
      )}
    </>
  );
};

export default Offcanvas;
